<div [ngClass]="{ 'hide': hidden }" id="myModal" class="modal">
	<!-- Modal content -->
	<div class="modal-content">
		<span class="close" (click)="close()">&times;</span>
		<ng-content></ng-content>
	</div>
</div>
